
<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-card flat >
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">{{heading}}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="#81DBF6"
      ></v-progress-linear>
    </v-toolbar>
    </v-card>

    <v-data-table
      :fixed-header="true"
      :headers="headers"
      :items="financial_maturity_report"
      :search="search"
      :height="520"
      hide-default-footer
      disable-pagination
      @current-items="getFiltered"
      class="elevation-12 mt-2"
    >

      <template v-slot:top>
        <v-container row>
          <v-text-field
            class="ml-3"
            hide-details
            outlined
            placeholder="search..."
            v-model="search"
            append-icon="mdi-magnify"
            dense
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-menu open-on-hover offset-y>
            <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
              EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
            </v-btn>
            </template>
            <v-list dense>
            <v-list-item class="ma-0 pa-0">
              <v-btn @click="generatePDF(false)" text small color="#2A353D">
                <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentFinancialMaturityReport"
                  type    = "xls"
                  name    = "Financial Maturity Report.xls">
    
                  <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
                </download-excel>
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentFinancialMaturityReport"
                  type    = "csv"
                  name    = "Financial Maturity Report.csv">
    
                  <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
                </download-excel>
              </v-btn>
            </v-list-item>
            </v-list>
          </v-menu>
          <v-btn @click="generatePDF(true)" outlined small color="#2A353D" class="ml-2" v-on="on">
            PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
          </v-btn>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import reportsService from '../services/reports.service';
import UserService from '../services/user.service';
import {mapGetters} from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      parameters: {},
      financial_maturity_report: [],
      CurrentFinancialMaturityReport: [],
      permitted: null,
      loading: false,
      permitted_dialog: true,
      search: '',
      message: '',
      heading: "Financial Maturity Report",
      headers: [
        {
          text: 'MaturityDate',
          align: 'start',
          sortable: false,
          value: 'MaturityDate',
          width: 220 
        },
        { text: 'AssetType', value: 'AssetType', sortable: false, width: 150},
        { text: 'CounterPartyName', value: 'CounterPartyName', sortable: false, width: 130 },
        { text: 'Instrument', value: 'Instrument', sortable: false, width: 200 },
        { text: 'PurchaseDate', value: 'PurchaseDate', sortable: false, width: 220 },
        { text: 'InstrumentValue', value: 'InstrumentValue', sortable: false },
        { text: 'DealNumber', value: 'DealNumber', sortable: false},
        { text: 'IsDiscount', value: 'IsDiscount', sortable: false},
        { text: 'GrossInterest', value: 'GrossInterest', sortable: false },
        { text: 'NetInterest', value: 'NetInterest', sortable: false },
        { text: 'MaturityValue', value: 'MaturityValue', sortable: false },
      ],
    }
  },

  computed: {
    ...mapGetters([
      "currentImage"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  created () {
    this.loading = true;
    reportsService.getFinancialMaturityReport()
    .then(response => {
      this.financial_maturity_report = response.data;
      this.loading = false
    },
    error => {
    this.message =
      (error.response && error.response.data.message) ||
      error.message ||
      error.toString();
      this.loading = false
    })
  },

  methods: {
    generatePDF(IsPrint) {
      const columns = [
        { title: 'Maturity Date',  dataKey: 'MaturityDate'},
        { title: 'Asset Type', dataKey: 'AssetType'},
        { title: 'Counter Party Name', dataKey: 'CounterPartyName'},
        { title: 'Instrument', dataKey: 'Instrument'},
        { title: 'Purchase Date', dataKey: 'PurchaseDate'},
        { title: 'Instrument Value', dataKey: 'InstrumentValue'},
        { title: 'Deal Number', dataKey: 'DealNumber'},
        { title: 'IsDiscount', dataKey: 'IsDiscount'},
        { title: 'Gross Interest', dataKey: 'GrossInterest'},
        { title: 'Net Interest', dataKey: 'NetInterest'},
        { title: 'Maturity Value', dataKey: 'MaturityValue'},
      ];

      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          var imgData = 'data:image/png;base64,'+ this.currentImage[0].data;

          doc.addImage(imgData, 'PNG', 0.5, 0.28, 1.3, 0.7);
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text(this.heading, 0.5, 1.0);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 1.1, 10.5, 1.1);
          doc.setLineWidth(0.01).line(0.5, 1.3, 10.5, 1.3);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 5.5, 8.2, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "landscape",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        columns,
        body: this.CurrentFinancialMaturityReport,
        margin: { left: 0.5, top: 1.1 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Financial Maturity Report.pdf')
      }
    },
    getFiltered(current){
      this.CurrentFinancialMaturityReport = current;
    },
    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },
  },

  mounted () {
    UserService.isReports().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.v-btn {
  outline: none
}
</style>